import React from 'react';
import {Text} from './styles';
import {theme} from '../../../../styles/darkTheme';

interface Props {
  error: any;
  visible: boolean;
}

const ErrorMessage: React.FC<Props> = ({error, visible}) => {
  if (!visible || !error) return null;

  return <Text theme={theme}>{error}</Text>;
};

export default ErrorMessage;
